import script from "./HeroSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeroSection.vue?vue&type=script&setup=true&lang=ts"

import "./HeroSection.vue?vue&type=style&index=0&id=665afe0a&scoped=true&lang=scss"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-665afe0a"]])

export default __exports__